import { ChangeDetectorRef, ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';

import { ClinicalTrialsUIService } from '../../services/clinical-trials-ui.service';
import { IClinicalTrialSubject } from '../../interfaces';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lib-clinical-trials-ui',
  styleUrls: ['./clinical-trials-ui.component.scss'],
  templateUrl: './clinical-trials-ui.component.html',
})
export class ClinicalTrialsUIComponent implements OnInit {

  @Input()
  patientID: string;

  @Input()
  associatedPartyID: string;

  clinicalTrialSubjectData: IClinicalTrialSubject[];

  constructor(
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly clinicalTrialsUIService: ClinicalTrialsUIService,
  ) {}

  ngOnInit(): void {
    this.clinicalTrialsUIService.getClinicalTrialSubjects(this.associatedPartyID, this.patientID).pipe(take(1)).subscribe(data => {
      this.clinicalTrialSubjectData = data;
      this.changeDetectorRef.markForCheck();
    });
  }
}
